import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 24px;
  border-radius: 4px;
  border: ${({ theme }) => `1px solid ${theme.defaultColors.info}`};
  background-color: ${({ theme }) => theme.defaultColors.infoBackground};
  font-size: 16px;
  line-height: 24px;
  margin: 20px 0 0 0;
`;

export const Heading = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  margin-bottom: 8px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const StyledLinkContainer = styled.div`
  padding: 1rem 0 0.2rem 0;
`;
